import React, { ReactElement } from 'react';
import { BsPerson } from 'react-icons/bs';
import { format } from 'date-fns';
import Image from "next/image";
import ShareArticleButtons from '@telesoft/ui/components/ui/share-article-buttons';
import { Admin, Post } from '@telesoft/types/payload-types';
import Grid from '@telesoft/ui/components/grid';
import Text from '@telesoft/ui/components/ui/text';

interface Props {
  author: Admin;
  article: Post;
}

function ArticlesAuthorInfo({
  author,
  article,
}: Props): ReactElement {
  const { photo, firstName = 'Team', lastName = 'Nucleus' } = author;

  const dateString = new Date(article.publishedDate);
  const formattedDate = format(dateString, 'do MMMM, yyyy');

  return (
    <Grid className="mt-8">
      <div className="col-span-4 flex flex-col border-t border-heading pt-4 justify-between items-start">
        <h5 className="text-xs opacity-50 mb-1 text-black lg:mb-2 lg:mt-0">
          Written by
        </h5>
        <div className="flex justify-start items-center">
          <div className="relative w-10 h-10 bg-accent-1 flex justify-center items-center mr-4">
            {photo && typeof photo !== 'string' ?  (
              <Image
                src={`${process.env.NEXT_PUBLIC_ASSET_URL}/${photo?.filename}`}
                alt="Author"
                layout="fill"
                className="object-cover object-center"
              />
            ) : (
              <BsPerson className="opacity-40" />
            )}
          </div>
          <div className="flex flex-col justify-start items-start">
            <Text className="text-sm text-black font-medium border-b border-telesoft">
              <span>{firstName} {lastName}</span>
            </Text>
            <h5 className="text-xs text-body mt-1 uppercase">CONTENT</h5>
          </div>
        </div>
      </div>

      <div className="col-span-4 flex flex-col border-t border-heading justify-start items-start pt:6 sm:pt-0">
        <h5 className="text-xs opacity-50 lg:mb-2 pt-4 lg:mt-0">Published on</h5>

        <Text className="text-sm text-black font-medium">{formattedDate}</Text>
      </div>
      <ShareArticleButtons article={article} />
    </Grid>
  );
}

export default ArticlesAuthorInfo;
